import PropTypes from "prop-types";
import React, { Component } from "react";
import CatalogCollection from "collections/catalogs";
import { LayoutManager } from "components/buzz-lightyear";
import CircularProgress from "material-ui/CircularProgress";
import Catalog from "./catalog";
import shallowequal from "shallowequal";
import Globalize from "globalize";
import { DATATEST } from "constants/integration";

import InfiniteMixin from "components/utils/infinite-mixin";

const styles = {
    base: {
        height: "100%",
        padding: "0 8px",
        position: "relative",
    },
    loadingContainer: {
        padding: "20px 0",
        textAlign: "center",
        width: "100%",
        float: "none",
    },
    noResults: {
        textAlign: "center",
        padding: "20px 10px",
        fontSize: "20px",
    },
};

@InfiniteMixin({ watchFilters: false, watchSort: false })
class Catalogs extends Component {
    static propTypes = {
        item: PropTypes.object,
        bulkItems: PropTypes.object,
        entities: PropTypes.object,
        type: PropTypes.oneOf(["item", "catalog"]),
        filters: PropTypes.object,
        searchTerm: PropTypes.string,
        listSearch: PropTypes.string,
        onRequestClose: PropTypes.func,
        catalogType: PropTypes.string.isRequired,
        currentCatalog: PropTypes.object,
        dialog: PropTypes.bool,
        onChangeCatalog: PropTypes.func,
        notes: PropTypes.string,
        scope: PropTypes.object.isRequired,
        sortBy: PropTypes.string,
        sortOrder: PropTypes.string,
        positionToAdd: PropTypes.string,
        onSnackbarAdd: PropTypes.func,
        active: PropTypes.bool,
    };

    static defaultProps = {
        dialog: true,
    };

    constructor(props) {
        super(props);
        this.state = {
            sort: "modified_on",
            sortOrder: "desc",
        };

        this.collection = new CatalogCollection();

        this.layoutManager = new LayoutManager({
            dragDrop: false,
            componentTypes: {
                catalog: {
                    Component: Catalog,
                    height: props.dialog ? 100 : 40,
                },
            },
        });
    }

    UNSAFE_componentWillMount() {
        this.fetchNextPage(true);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { sort, sortOrder } = this.state;
        const listSearch = nextProps.listSearch;
        if (this.props.listSearch !== listSearch) {
            this.fetchNextPage(true, nextProps, {
                sort,
                sortOrder,
                listSearch,
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            !shallowequal(this.props, nextProps) ||
            !shallowequal(this.state, nextState) ||
            !shallowequal(this.context, nextContext)
        );
    }

    handleFetchSuccess(xhr, data) {
        const {
            item,
            bulkItems,
            type,
            entities,
            filters,
            searchTerm,
            onRequestClose,
            currentCatalog,
            onChangeCatalog,
            onSnackbarAdd,
            onSelect,
            notes,
            scope,
            sortBy,
            sortOrder,
            positionToAdd,
        } = this.props;

        const catalogs = this.collection;

        catalogs.models.slice(catalogs.length - data.length).forEach((catalog) => {
            if (currentCatalog && catalog.id === currentCatalog.id) {
                return;
            }
            this.layoutManager.addComponent(
                {
                    catalog,
                    currentCatalog,
                    item,
                    bulkItems,
                    filters,
                    searchTerm,
                    onRequestClose,
                    onChangeCatalog,
                    type,
                    entities,
                    notes,
                    onSnackbarAdd,
                    scope,
                    onSelect,
                    sortBy,
                    sortOrder,
                    positionToAdd,
                },
                "catalog",
            );
        });
    }

    enhanceQueryParams(query, props) {
        query = query.set("type", this.props.catalogType);
        if (this.props.catalogType === "custom-list") {
            query = query.set("shared", false);
        }

        if (props.listSearch) {
            query = query.set("__search", props.listSearch);
        }

        if (props.active !== undefined) {
            query = query.set("active", props.active);
        }

        query = query.set("__sort", "modified_on").set("__sort_order", "DESC");
        return query;
    }

    render() {
        return (
            <div style={styles.base}>
                {this.getScrollContainer({
                    loadingSpinner: (
                        <div style={styles.loadingContainer}>
                            <CircularProgress mode="indeterminate" data-test="list-circular-progress" />
                        </div>
                    ),
                    emptyResults: <div style={styles.noResults}>{Globalize.formatMessage("No results found")}</div>,
                    dataTest: DATATEST.CATALOG.CATALOG_LIST,
                    dragDrop: false,
                    height: this.props.dialog ? 400 : 200,
                })}
            </div>
        );
    }
}

export default Catalogs;
